import { Component, inject, Input } from '@angular/core';
import { Store } from '@ngrx/store';
import { fromToolbar, ToolbarActions } from 'shared/classroom/toolbar/data-access';
import { map } from "rxjs/operators";
import { ToolbarButtonComponent } from '../toolbar-button.component';
import { AsyncPipe } from '@angular/common';


@Component({
    selector: 'pcp-slide-sync-toolbar-button-bookpage-list',
    templateUrl: './toolbar-button-bookpage-list.component.html',
    styleUrls: ['./toolbar-button-bookpage-list.component.scss'],
    imports: [ToolbarButtonComponent, AsyncPipe]
})
export class ToolbarButtonBookpageListComponent {

    @Input() icon = 'import_contacts';
    @Input() fontSet = '';

    private readonly store: Store = inject(Store);

    readonly isDrawingEnabled$ = this.store.select(
        fromToolbar.isDrawingEnabled
    );

    readonly isActivated$ = this.store.select(
        fromToolbar.isBookpageToolActivated
    );

    readonly isDisabled$ = this.store.select(
        fromToolbar.selectIsBookpageToolEnabled
    ).pipe(
        map(isEnabled => !isEnabled),
    );

    public toggleBookpageListDialog() {
        this.store.dispatch(ToolbarActions.toggleBookpageTool());
    }
}
